/**
 Adzuki.DropdownLinks
 a select menu that will redirect to URLs on change

 Example Usage:

  <select class="form-control dropdown-links">
    <option value="">Select Action</option>
    <option value="/Ships/view/1">View</option>
  </select>

  When the dropdown is changed, it will redirect to the URL value for the option
*/

(function DropdownLinks($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		if ($('.dropdown-links').length > 0) {
			$('.dropdown-links').change(function doUrl(e) {
				var $self            = $(this),
				    val              = $self.val(),
				    url              = Adzuki.base_uri + val,
				    $selected_option = $self.find(":selected");

				if (val.length < 1) {
					return false;
				}

				if ($selected_option.data('confirm-msg')) {
					Adzuki.CustomConfirm({
						body: $selected_option.data('confirm-msg'),
						url : url,
					});
				} else if ($selected_option.data('record-type') === 'deal') {
					let record_type    = $selected_option.data('record-type'),
						record_type_hr = $selected_option.data('record-hr'),
						record_id      = $selected_option.data('record-id');

					let $modal = $('.modal');

					Adzuki.Ajax.get('/MarketingTags/tag/' + record_type + '/' + record_id + '/' + record_type_hr)
					.then(function _letsGetEmTagged(content) {
			
						$modal.find('.modal-title').text("Tag Marketing Item");
						$modal.find('.modal-body').html(content);
			
						Adzuki.Form.initAjaxForm('MarketingTagItem');
			
						$modal.on('hidden.bs.modal', function _restoreModal() {
							$modal.removeClass('wide').off('hidden.bs.modal');
						}).modal('show');
					});
				} else {
					document.location = url;
				}
			});
		}
	});
}(jQuery, window.Adzuki || {}));
